module.exports = __webpack_public_path__ + "img/play.e97275ad.png";